import React from 'react';
import {FormattedMessage} from "react-intl";

import {useFormikContext} from "formik";

import Grid from "@mui/material/Grid";

import CustomButton from "components/CustomButton";
import Label from "components/input/new/Label";
import {ReactComponent as AddIcon} from "assets/img/add-circle.svg";

import MetadataRow from "./MetadataRow";

import {MetadataTypes} from "../../utils/metadata";

function MetadataFields(props) {
    const {values, setFieldValue} = useFormikContext();

    const metadata = values.metadata ?? [];

    function addMetadata() {
        setFieldValue('metadata', [
            ...metadata,
            {key: '', type: MetadataTypes.STRING, value: ''}
        ]);
    }

    function deleteMetadata(index) {
        setFieldValue('metadata', metadata.filter((item, currentIndex) => currentIndex !== index));
    }

    return (
        <Grid container rowSpacing={2}>
            {metadata.length > 0 && (
                <Grid item container columnSpacing={1} flexWrap={'nowrap'}>
                    <Grid item xs={4}>
                        <Label htmlFor={'metadata'}>
                            <FormattedMessage id={'shippingMethods.form.field.metadata.key.label'} />
                        </Label>
                    </Grid>
                    <Grid item xs={3}>
                        <Label htmlFor={'metadata'}>
                            <FormattedMessage id={'shippingMethods.form.field.metadata.type.label'} />
                        </Label>
                    </Grid>
                    <Grid item xs={4}>
                        <Label htmlFor={'metadata'}>
                            <FormattedMessage id={'shippingMethods.form.field.metadata.value.label'} />
                        </Label>
                    </Grid>
                    <Grid item xs={1} />
                </Grid>
            )}
            {metadata.map((item, index) => (
                <MetadataRow
                    key={index}
                    index={index}
                    metadata={item}
                    onDelete={deleteMetadata}
                />
            ))}
            <Grid item xs={12}>
                <CustomButton
                    color={'lightBlue'}
                    onClick={addMetadata}
                >
                    <Grid container gap={'8px'} justifyContent={'center'} alignItems={'center'}>
                        <AddIcon />
                        <FormattedMessage id={'shippingMethods.form.field.metadata.button.add'} />
                    </Grid>
                </CustomButton>
            </Grid>
        </Grid>
    );
}

export default MetadataFields;
